var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "add_task"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_562_3220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 13
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_562_3220)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add_task_2",
    d: "M5.99976 11.5001C5.30809 11.5001 4.65809 11.3689 4.04976 11.1064C3.44142 10.8439 2.91226 10.4876 2.46226 10.0376C2.01226 9.58762 1.65601 9.05845 1.39351 8.45012C1.13101 7.84179 0.999756 7.19179 0.999756 6.50012C0.999756 5.80845 1.13101 5.15845 1.39351 4.55012C1.65601 3.94179 2.01226 3.41262 2.46226 2.96262C2.91226 2.51262 3.44142 2.15637 4.04976 1.89387C4.65809 1.63137 5.30809 1.50012 5.99976 1.50012C6.54142 1.50012 7.05392 1.57929 7.53726 1.73762C8.02059 1.89596 8.46642 2.11679 8.87476 2.40012L8.14976 3.13762C7.83309 2.93762 7.49559 2.78137 7.13726 2.66887C6.77892 2.55637 6.39976 2.50012 5.99976 2.50012C4.89142 2.50012 3.94767 2.88971 3.16851 3.66887C2.38934 4.44804 1.99976 5.39179 1.99976 6.50012C1.99976 7.60845 2.38934 8.5522 3.16851 9.33137C3.94767 10.1105 4.89142 10.5001 5.99976 10.5001C6.26642 10.5001 6.52476 10.4751 6.77476 10.4251C7.02476 10.3751 7.26642 10.3043 7.49976 10.2126L8.24976 10.9751C7.90809 11.1418 7.54976 11.271 7.17476 11.3626C6.79976 11.4543 6.40809 11.5001 5.99976 11.5001ZM9.49976 10.5001V9.00012H7.99976V8.00012H9.49976V6.50012H10.4998V8.00012H11.9998V9.00012H10.4998V10.5001H9.49976ZM5.29976 8.80012L3.17476 6.67512L3.87476 5.97512L5.29976 7.40012L10.2998 2.38762L10.9998 3.08762L5.29976 8.80012Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTask);
export default __webpack_public_path__ + "static/media/add_task.5d2138a1c137699f8e7979b1870c1a0b.svg";
export { ForwardRef as ReactComponent };